import styled from 'styled-components'

const ModalHeader = styled.div`
  align-items: center;
  display: flex;
  height: 68px;
  justify-content: space-between;
`

export default ModalHeader
